const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/portfolio/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { requirePermission } from '@/lib/hooks/common/usePermissions';
import { itemPanelSearchSchema } from '@/lib/zod-schemas/itemPanelSearchSchema';
const portfolioSearchSchema = itemPanelSearchSchema.extend({
  teamId: z.preprocess((v: unknown) => v === '' || v === undefined ? undefined : Number(v), z.number().int().positive().optional()).optional(),
  selectAll: z.preprocess((v: unknown) => v === 'true' || v === true, z.boolean().optional()).optional(),
  createInstance: z.string().optional(),
  oauthCredentialsId: z.number().optional(),
  loopId: z.number().optional(),
  callbackSource: z.string().optional()
});
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/portfolio')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(portfolioSearchSchema),
  beforeLoad: requirePermission('edit_planner')
});